export function getQuoteBySymbolAndName(quotes, symbol, name) {
  let quote = quotes.find(
    (quote) =>
      quote.symbol &&
      symbol &&
      quote.symbol.toUpperCase() === symbol.toUpperCase() &&
      quote.name &&
      name &&
      quote.name.toUpperCase() === name.toUpperCase(),
  );
  if (!quote) {
    quote = quotes.find(
      (quote) =>
        quote.relatedSymbol &&
        symbol &&
        quote.relatedSymbol.toUpperCase() === symbol.toUpperCase() &&
        quote.name &&
        name &&
        quote.name.toUpperCase() === name.toUpperCase(),
    );
  }
  return quote;
}

export function getQuoteBySymbol(quotes, symbol) {
  let quote = quotes.find((quote) => quote.symbol && symbol && quote.symbol.toUpperCase() === symbol.toUpperCase());
  if (!quote) {
    quote = quotes.find(
      (quote) => quote.relatedSymbol && symbol && quote.relatedSymbol.toUpperCase() === symbol.toUpperCase(),
    );
  }
  return quote;
}
